const debug = require('debug')('plugin:dom');
const lload = require('little-loader');
const xhr = require('xhr');

const openRequests = [];

const dom = {
	clearRequest(xhrObj) {
		if (xhrObj) {
			const index = openRequests.indexOf(xhrObj);
			if (openRequests[index]) {
				openRequests.splice(index, 1);
			}
		}
	},

	abortAllRequests() {
		openRequests.forEach((req) => {
			if (req && req.abort) {
				req.abort();
				dom.clearRequest(req);
			}
		});
	},

	// If you want to async (no load ordering) load scripts
	lloadScripts(_scripts, callback) {
		debug('lloadScripts', _scripts);
		const scripts = (Array.isArray(_scripts)) ? _scripts : [_scripts];
		const completed = [];

		function onComplete(err, script) {
			debug('lloadScripts:onComplete', err, script);
			completed.push({ err, script });
			// TODO - handle error/retry
			if (completed.length >= scripts.length) {
				callback(null, completed);
			}
		}

		scripts.forEach((script) => {
			lload(script, (err) => {
				onComplete(err, script);
			});
		});
	},

	// This will xhr fetch the string contents of an array of JS files
	loadScripts(_scripts, callback) {
		debug('loadScripts', _scripts);
		const scripts = (Array.isArray(_scripts)) ? _scripts : [_scripts];
		const completed = [];
		let counter = 1;

		if (scripts.length === 0) {
			callback(null, []);
		}

		function onComplete(id) {
			return (err, response) => {
				const { body, rawRequest } = response;
				debug('loadScripts:onComplete', response, counter);
				completed.forEach((item) => {
					if (item.id === id) {
						item.content = body;
					}
				});
				// TODO - handle error/retry
				if (counter >= scripts.length) {
					callback(null, completed);
					dom.clearRequest(rawRequest);
				} else {
					counter += 1;
				}
			};
		}

		scripts.forEach((script) => {
			completed.push({
				id: script.id,
				src: script.src,
				content: undefined,
			});
			debug('loadScripts:fetch', script);
			const xhrObj = xhr({
				method: 'get',
				url: script.src,
				json: false,
			}, onComplete(script.id));
			openRequests.push(xhrObj);
		});
	},

	// This will xhr fetch the string contents of an array of CSS files
	loadStyles(_styles, callback) {
		debug('loadStyles', _styles);
		const styles = (Array.isArray(_styles)) ? _styles : [_styles];
		const completed = [];

		if (styles.length === 0) {
			callback(null, []);
		}

		function onComplete(err, response) {
			const { body, url, rawRequest } = response;
			debug('loadStyles:onComplete', response);
			const style = {
				err,
				style: dom.upsertStyle({ content: body, id: url, href: url }),
			};
			completed.push(style);
			// TODO - handle error/retry
			if (completed.length >= styles.length) {
				callback(null, completed);
				dom.clearRequest(rawRequest);
			}
		}

		styles.forEach((style) => {
			debug('loadStyles:fetch', style);
			const xhrObj = xhr({
				method: 'get',
				url: style,
				json: false,
			}, onComplete);
			openRequests.push(xhrObj);
		});
	},

	// Will do element empty->insert with given content
	replaceContent(el, content, callback) {
		debug('replaceContent - start');
		while (el.lastChild) {
			el.removeChild(el.lastChild);
		}
		el.insertAdjacentHTML('afterbegin', content);
		debug('replaceContent - end');
		setTimeout(callback, 0);
	},

	// Will get CSSRule objects from a <link> element
	getStyleRulesFromLink(linkEl = {}) {
		debug('getStyleRulesFromLink', linkEl);
		if (linkEl.sheet) {
			const sheet = linkEl.sheet;
			const rules = sheet.cssRules || sheet.rules || {};
			debug('getStyleRulesFromLink', sheet, rules);
			if (rules.length) {
				return dom.getRulesArrayFromRulesList(rules);
			}
		}

		return [];
	},

	// Transforms a Rules list into a JS Array
	getRulesArrayFromRulesList(list) {
		const result = [];
		for (let index = 0; index < list.length; index++) {
			if (list[index] && typeof list[index] === 'object') {
				result.push(list[index]);
			}
		}
		return result;
	},

	// Adds styles to page by way of removing styles with the same ID first
	upsertStyle({ content, id: _id, href }) {
		const id = `${_id}-style`;
		let el = document.getElementById(id);

		if (!el) {
			el = document.createElement('style');
			el.id = id;
			el.type = 'text/css';
			el.href = href;
		} else {
			while (el.lastChild) {
				el.removeChild(el.lastChild);
			}
		}
		el.appendChild(document.createTextNode(content));
		return document.head.appendChild(el);
	},

	// Only use this ONCE per unique script.... at least Chrome holds references in memory and will cause repeat executions per inclusion
	// I'm not currently using this due to complications
	insertScript({ src, id: _id, async = false, onload, scriptBody, removePrevious = false, parentEl }) {
		const targetEl = parentEl || document.head;
		if (removePrevious) {
			let el = document.getElementById(_id);
			if (el) {
				el.parentNode.removeChild(el);
			}
		}

		const el = document.createElement('script');
		if (_id) {
			el.id = `${_id}-script`;
		}
		el.type = 'text/javascript';
		if (scriptBody) {
			el.innerHTML = scriptBody;
		} else {
			el.src = src;
			el.async = async;
		}

		if (onload) {
			el.onload = onload;
		}
		debug('insertScript', src || 'inline script', el.id || scriptBody);
		return targetEl.appendChild(el);
	}
};

module.exports = dom;
